import {
  updateChunksFilterByIdType,
  syncAllChunksWithGroupsType,
  deselectAllChunksOfFilterType,
  updateCustomGroupsByIdType,
  updateGroupByIdInChunksOfFilterType,
} from '../ListOfFiltersConstants';

export function updateCustomGroupsDataById(key, filterId, data) {
  return {
    type: updateCustomGroupsByIdType,
    payload: {
      key,
      filterId,
      data,
    },
  };
}

export function updateChunksFilterById(
  key,
  filterId,
  sortingType,
  sorting,
  data,
  chunkIndex,
  letter,
  customGroupsWithByValueSorting,
  isSortingChanged,
  isSortingTypeChanged
) {
  return {
    type: updateChunksFilterByIdType,
    payload: {
      key,
      data,
      sorting,
      filterId,
      sortingType,
      chunkIndex,
      letter,
      customGroupsWithByValueSorting,
      isSortingChanged,
      isSortingTypeChanged,
    },
  };
}

export function updateGroupByIdInChunksOfFilter(key, filterId, groupId, data) {
  return {
    type: updateGroupByIdInChunksOfFilterType,
    payload: {
      key,
      data,
      groupId,
      filterId,
    },
  };
}

export function deselectAllChunksOfFilter(key, filterId) {
  return {
    type: deselectAllChunksOfFilterType,
    payload: {
      key,
      filterId,
    },
  };
}

export function syncAllChunksWithGroups(key, filterId) {
  return {
    type: syncAllChunksWithGroupsType,
    payload: {
      key,
      filterId,
    },
  };
}
